import { getThankfulBaseUrl } from 'src/presentation/components/pages/sidekick/threads/utils/utils';
import sidekickCustomerResource from 'src/actions/sidekick/sidekickCustomerResource';
import sidekickFastThreadsResource from 'src/actions/sidekick/sidekickFastThreadsResource';
import { useResourceValue } from 'src/presentation/hooks/useDocumentResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';
import useRouter from 'src/presentation/hooks/useRouter';

type UseOpenThreadProps = {
  root: string;
};

const useOpenThread = ({ root }: UseOpenThreadProps) => {
  const { history } = useRouter();
  const { values: threads } = useResourceValues(sidekickFastThreadsResource);
  const { value: customer } = useResourceValue(sidekickCustomerResource);

  const handleOpenThread = (threadId: string) => {
    if (!threads || !threads.length) {
      return;
    }

    const thread = threads.find(thread => String(thread.id) === String(threadId));
    if (thread?.next) {
      history.push(`${root}/${threadId}`);
      return;
    }

    redirectToLegacyThread(thread.id, getThankfulBaseUrl(customer));
  };

  return { handleOpenThread };
};

export default useOpenThread;

function redirectToLegacyThread(threadId: number, baseUrl: string) {
  const url = `${baseUrl}/flows/${threadId}`;
  window.open(url, '_blank');
}
